module.exports = __webpack_public_path__ + "media/2.ca7bc6a6.mp3";